import { Subscription } from '../../../../data/dietitian/domain/subscription/subscription';

export interface SideBarItem {
  icon: string;
  label: string;
  selected: boolean;
  navigateTo?: string;
  url?: string;
  tabValue: SideBarNavigationTabs;
  condition: (sub: Subscription | undefined) => boolean;
  onlyDesktop: boolean;
}

export enum SideBarNavigationTabs {
  QUESTIONS = 'DASHBOARD',
  TEMPLATES = 'TEMPLATES',
  QUIZ_TEMPLATES = 'QUIZ_TEMPLATES',
  DOCUMENTS = 'DOCUMENTS',
  TRACKERS = 'TRACKERS',
  GROUPS = 'GROUPS',
  MON_SUIVI_DIET_PLUS = 'MON_SUIVI_DIET_PLUS',
  ACCOUNT = 'ACCOUNT',
  USER_GUIDE = 'USER_GUIDE',
  NUTRITIONS = 'NUTRITIONS',
  BILLING = 'BILLING',
}
